export default {
  methods: {
    goBack() {
      this.$router.back();
    },
    goToHome() {
      this.$router.push('/');
    },
    goToSignIn() {
      this.$router.push('/anmelden');
      location.reload();
    },
    goTo(path) {
      this.$router.push(path);
    }
  },
};
